import React from 'react';
import Images from '../../img';
import Utils from './utils'

const InlineSvg = React.createClass({

  render() {
    return <span className="inline-svg">{Utils.toHTML(Images[this.props.src])}</span>
  }

});

export default InlineSvg;



/** WEBPACK FOOTER **
 ** ./src/js/utils/inline-svg.jsx
 **/